import * as React from 'react';

import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkScrollable } from 'uitk-react-scrollable';
import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from './map/map-preview';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';

export const Filterbar: React.FunctionComponent = () => (
    <Viewport>
      <ViewSmall>
        <Buttons withMapButton={true} borderSetting={'unset'} />
      </ViewSmall>
      <ViewMedium>
        <Buttons withMapButton={true} borderSetting={'unset'} />
      </ViewMedium>
      <ViewLarge>
        <Buttons withMapButton={false} borderSetting={'unset'} />
      </ViewLarge>
    </Viewport>
  );

Filterbar.displayName = 'Filterbar';

interface ButtonsProps {
  withMapButton?: boolean;
  borderSetting: 'unset' | 'blockstart' | 'blockend' | 'inlinestart' | 'inlineend';
}

const Buttons = ({ withMapButton, borderSetting }: ButtonsProps) => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();

  return (
    <UitkSpacing padding={{ small: { block: 'two' }, medium: { block: 'four' } }} border={[borderSetting]}>
      <UitkScrollable direction="horizontal">
        <UitkSpacing margin={{ small: { inline: 'three' }, medium: { inline: 'unset' }, large: { inline: 'unset' } }}>
          <UitkLayoutFlex justifyContent="space-between">
            <UitkLayoutFlexItem>
              <div>
                <UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTER_BAR} />
              </div>
            </UitkLayoutFlexItem>
            {withMapButton && (
              <UitkLayoutFlexItem data-testid="map-preview-button">
                <div>
                  <MapPreview viewTracker={viewTracker} tracker={tracker} />
                </div>
              </UitkLayoutFlexItem>
            )}
          </UitkLayoutFlex>
        </UitkSpacing>
      </UitkScrollable>
    </UitkSpacing>
  );
};
